module.exports = __webpack_public_path__ + "img/photo-0077.b345a753.jpg";